import { vueI18n } from '@adobe/edex/ui/shared/services/i18n';
import store from '@adobe/edex/frontend/store';
import en from '@adobe/edex/ui/shared/i18n/en-us.json';
import { getLoader, getSessionLocale, setSessionLocale } from '@adobe/edex/ui/shared/config/i18n';
import { Locale } from '@adobe/edex/ui/shared/constants';

const locales = {};

export async function loadLocale(locale: Locale = Locale.en) {
  if (locale in locales) {
    return locales[locale];
  }

  const promise = getLoader(locale);

  locales[locale] = promise;
  locales[locale] = await promise;
  return locales[locale];
}

export async function initVueLocale(locale: Locale = Locale.en) {
  document.documentElement.lang = locale;
  setSessionLocale(locale);
  store.dispatch('config/changeLocale', locale);

  const translations = await loadLocale(locale);
  vueI18n.setLocaleMessage(locale, { ...en, ...translations }); // merge in case of db missing labels
  vueI18n.locale = locale;
}

export { getSessionLocale, setSessionLocale };
